<script>
/**
 * The goal of <oc-inline-component> component is to fix Vue issue with functional components and provide/inject:
 * https://github.com/vuejs/vue/issues/5837
 *
 * It is an empty component and you should always use it with "inline-template"
 * https://vuejs.org/v2/guide/components-edge-cases.html#Inline-Templates
 *
 * Usage:
 *
 * ```
 * <oc-inline-component inline-template>
 *     <my-functional-component-here />
 * </oc-inline-component>
 * ```
 *
 * This component is only needed when you have provide/inject in your functional component.
 */
export default {
    name: 'oc-inline-component'
}
</script>
